import { useMemo, useState } from 'react'
import useUsersBarrilitoTable from './useUsersBarrilitoTable'
import CustomTable from '../Custom/Table'
import TableSearch, { filterRows } from '../Custom/TableSearch'
import useExcelExport from './useExcelExport';

const UsersBarrilitoTable = () => {

    const { columns } = useUsersBarrilitoTable();
    const {  usersBarrilito } = useExcelExport()
    const [filtroBusqueda, setFiltroBusqueda] = useState('')

    const usersFiltrados = useMemo(
        () => filterRows(usersBarrilito, filtroBusqueda, ['nombre', 'apellidoPaterno', 'apellidoMaterno', 'email', 'interes', 'interes_otro']),
        [usersBarrilito, filtroBusqueda]
    )

    return (
        <>
            <TableSearch
                value={filtroBusqueda}
                onChange={setFiltroBusqueda}
                label="Buscar usuario"
                placeholder="Nombre, apellidos, email o interés..."
            />
            <CustomTable rows={usersFiltrados} columns={columns} />
        </>
    )

};

export default UsersBarrilitoTable;
